import {CrossSellType} from "../../definitions/types";
import {mapper} from "../../utils/helpers";
import {CrossSellModel} from "../domain/crossSellModel";

export class ReplacementPartsModel {
    private readonly _replacementParts: CrossSellModel[];

    constructor(public readonly crossSells: CrossSellType[]) {
        this._replacementParts = crossSells.map(replacementPart => mapper.crossSellToModel(replacementPart));
    }

    /**
     * @method replacementParts
     * @description Gets the replacement parts items for the model instance.
     * @returns {CrossSellModel[]}
     */
    public get replacementParts(): CrossSellModel[] {
        return this._replacementParts;
    }

    /**
     * @method count
     * @description Gets the count of replacement parts items for the model instance.
     * @returns {number}
     */
    public get count(): number {
        return this._replacementParts.length;
    }

    /**
     * @method hasReplacementParts
     * @description Returns true if the model instance has replacement parts items.
     * @returns {boolean}
     */
    public get hasReplacementParts(): boolean {
        return this.count > 0;
    }
}